import vehiclesAPI from "../../API/endpoints/vehicles";
import { sliceActions } from "../vehicles-slice";

export const fetch = () => {
  return async (dispatch) => {
    try {
      const response = await vehiclesAPI.get();
      dispatch(sliceActions.populateData(response.data));
      dispatch(sliceActions.populateOptions(response.data));
    } catch (error) {
      console.log(error);
    }
  };
};

export const create = (payload) => {
  return async (dispatch) => {
    try {
      await vehiclesAPI.create(payload);
      dispatch(fetch());
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const remove = (id) => {
  return async (dispatch) => {
    try {
      await vehiclesAPI.delete(id);
      dispatch(fetch());
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const activate = (id) => {
  return async (dispatch) => {
    try {
      await vehiclesAPI.activate(id);
      dispatch(fetch());
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const deactivate = (id) => {
  return async (dispatch) => {
    try {
      await vehiclesAPI.deactivate(id);
      dispatch(fetch());
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};
